import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";

import graphQLApiSlice from "web/features/api/graphQLApiSlice";
import { RootState } from "web/store";

import selectBankCountsForPaymentSortContext from "./selectBankCountsForPaymentSortContext";

const getBankCountForPaymentSortContext = async (
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
  getState: () => RootState
) => {
  const bankCountsResult =
    graphQLApiSlice.endpoints.getPointsBankProductCounts.select()(getState());

  if (!bankCountsResult?.data) {
    await dispatch(
      graphQLApiSlice.endpoints.getPointsBankProductCounts.initiate()
    ).unwrap();
  }

  return selectBankCountsForPaymentSortContext(getState());
};

export type TBankCountsForPaymentSortContext = Awaited<
  ReturnType<typeof getBankCountForPaymentSortContext>
>;

export default getBankCountForPaymentSortContext;
